import React from "react";
import { useTableGlobalInvoicesConfig } from "./hooks";
import { useSelector } from "react-redux";
import { AutocompleteComponent } from "components/Autocomplete/AutocompleteComponent";

export const GlobalInvoicesSelectStation = () => {
  const { handleInputs } = useTableGlobalInvoicesConfig();
  const { stationsList } = useSelector(({ companies }) => companies);
  const station = useSelector(({ globalInvoices }) => globalInvoices.station);

  return (
    <AutocompleteComponent
      id="global-invoice-station-input"
      name="station"
      options={stationsList}
      value={station}
      filterSelectedOptions
      fullWidth
      handleValues={({ station }) => handleInputs("station", station)}
      noOptionsText="No se encuentra la planta"
      size="small"
    />
  );
};
